import { render } from "./_ChatSeongsuFlat.vue?vue&type=template&id=b75c61cc"
import script from "./_ChatSeongsuFlat.vue?vue&type=script&lang=js"
export * from "./_ChatSeongsuFlat.vue?vue&type=script&lang=js"

import "@/css/chatbot.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__